var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66683 0.666504H2.00016C1.55814 0.666504 1.13421 0.842099 0.821651 1.15466C0.509091 1.46722 0.333496 1.89114 0.333496 2.33317V15.6665C0.333496 16.1085 0.509091 16.5325 0.821651 16.845C1.13421 17.1576 1.55814 17.3332 2.00016 17.3332H12.0002C12.4422 17.3332 12.8661 17.1576 13.1787 16.845C13.4912 16.5325 13.6668 16.1085 13.6668 15.6665V5.6665L8.66683 0.666504ZM8.25016 12.3332V14.8332H5.75016V12.3332H3.66683L7.00016 8.99984L10.3335 12.3332H8.25016ZM7.8335 6.49984V1.9165L12.4168 6.49984H7.8335Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadAttachment);
export default __webpack_public_path__ + "static/media/UploadAttachment.d60257bf24588b4717b9caa03cb6b879.svg";
export { ForwardRef as ReactComponent };